<template>
    <div ref="tdTopSiteMessage">

        <div :class="'td-top-site-message td-' + subscriptionStatus.replace('_','-')" v-if="topSiteMessage !== '' && $store.getters.isAdmin">
            <router-link v-if="(subscriptionStatus === 'trial_expired' || subscriptionStatus === 'subscription_expired') && $store.getters.isAdmin " to="/checkout" class="td-top-site-message-link"></router-link>
            <a :href="$__('https://iflow.ro/en/contact-us')" v-if="(subscriptionStatus === 'too_many_employees') && $store.getters.isAdmin " class="td-top-site-message-link"></a>
            <div class="container td-top-site-message-wrap">
                <div class="col-md-12 td-top-site-message-body">
                    <div class="td-top-site-message-text" v-html="topSiteMessage"></div>
                    <span v-if="(subscriptionStatus === 'trial_expired' || subscriptionStatus === 'subscription_expired') && $store.getters.isAdmin && $store.state.company.country_code !== 'RO'" class="td-top-site-message-buy">{{$__('Buy now')}}</span>
                    <span v-if="(subscriptionStatus === 'trial_expired' || subscriptionStatus === 'subscription_expired') && $store.getters.isAdmin && $store.state.company.country_code === 'RO'" class="td-top-site-message-buy">{{$__('Contact us')}}</span>
                    <span v-if="(subscriptionStatus === 'too_many_employees') && $store.getters.isAdmin " class="td-top-site-message-buy">{{$__('Contact us')}}</span>
                </div>
            </div>
        </div>

        <div class="td-top-site-message" v-if="updateMessage !== ''">
            <div class="container td-top-site-message-wrap">
                <div class="col-md-12">
                    <div class="td-top-site-message-text" v-html="updateMessage"></div>
                    <div class="td-top-site-message-close">
                        <a href="#" @click.stop.prevent="closeUpdateMessage" class="td-icon-close"></a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import tdDeploy from '../tdDeploy.js';
    import tdApi from '../tdApi.js';

    export default {
        data() {
            return {
                message: '',

                updateMessage: '',
                //cookieName: tdDeploy.topSiteMessageCookie,
                // @since 17.3.2021 -
                // @todo - make some system that dosn't show the banner on each update
                cookieName: tdDeploy.topSiteMessageCookie, // prevent updates!
                status: null
            }
        },

        created() {
            this.updateTopSiteHeight();
            this.updateMessageStatus('get', this.cookieName);
        },

        methods: {
            closeUpdateMessage() {
                let vm = this;

                //vm.setCookie(vm.cookieName, 'false', 600);
                vm.updateMessageStatus('set', vm.cookieName);
                vm.updateMessage = '';
            },

            updateTopSiteHeight() {
                let vm = this;

                if (vm.updateMessage === '' && vm.topSiteMessage === '') {
                    vm.$emit('tdTopSiteMessageHeight', 0);
                } else {
                    vm.$nextTick(function() {
                        vm.$emit('tdTopSiteMessageHeight', vm.$refs.tdTopSiteMessage.clientHeight);
                    });

                }
            },

            // setCookie(cookieName, cookieValue, expireDays) {
            //     let expireDate = new Date(),
            //         dayInSeconds = 24*60*60*1000;
            //
            //     expireDate.setTime(expireDate.getTime() + (expireDays * dayInSeconds));
            //     let expires = "expires="+ expireDate.toUTCString();
            //     document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
            // },

            // getCookie(cookieName) {
            //     let name = cookieName + "=",
            //         decodedCookie = decodeURIComponent(document.cookie),
            //         ca = decodedCookie.split(';');
            //
            //     for (let i = 0; i < ca.length; i++) {
            //         let c = ca[i];
            //
            //         while (c.charAt(0) == ' ') {
            //             c = c.substring(1);
            //         }
            //
            //         if (c.indexOf(name) == 0) {
            //             return c.substring(name.length, c.length);
            //         }
            //     }
            //     return "";
            // },

            updateMessageStatus(type,key) {
                let vm = this,
                    currentLoggedInUser = vm.$store.state.user,
                    postData = {
                        type: type,
                        key: key,
                        user_id: currentLoggedInUser.ID
                    },
                    registerApiCall = new tdApi('auth/update_message_status');

                registerApiCall.run({
                    'post': { ...postData },
                    'done': function (apiReply) {
                        vm.status = apiReply.update_message_status;
                    }.bind(this),
                    'error': function (errorApiReply) {
                        window.EventBus.$emit(
                            'banner_onError',
                            'Failed to update message status',
                            errorApiReply
                        );
                    }.bind(this)
                });
            }
        },

        computed:{
            subscriptionStatus() {

                // disable the trial message and update message for the portable version
                if (window.tdDeployInject.deployType === 'portable') {
                    return '';
                }


                return this.$store.getters.getSubscriptionStatus;
            },
            topSiteMessage() {

                let vm = this,
                    message = '';

                switch(vm.subscriptionStatus) {
                    case 'trial_expired':
                        message = vm.$__('Your trial period has expired');
                        break;
                    case 'subscription_expired':
                        message = vm.$__('Your subscription has expired');
                        break;
                    case 'too_many_employees':
                        message = vm.$__('You have too many employees, you have to extend your subscription');
                        break;
                    case 'blocked':
                        if (vm.$store.state.company.country_code !== 'RO') {
                            message = vm.$__('Your account is currently blocked. Proceed with subscription payment and contact us at contact@iflow.ro to unblock.');
                        }
                        break;
                    default:
                        message = '';
                }

                //reset cookie (debug)
                //vm.setCookie(this.cookieName, 'true', 0);
                // let cookieData = vm.getCookie(vm.cookieName);

                // if vm.status is `true` .. means that the message should appear..
                //@since 28.10.2019 - hide the new update message on english sites! For now...
                if ( vm.status && vm.$store.state.company.country_code === 'RO' ) {
                    vm.updateMessage = vm.$__('iFlow app has been updated! Learn more') + ' <a target="_blank" class="top-site-btn" href="https://iflow.ro/evaluarea-angajatilor">' + vm.$__('Here') + '<a>'
                }

                //vm.updateTopSiteHeight();

                return message;
            },
        },

        watch: {
            topSiteMessage(newValue) {
                this.updateTopSiteHeight();
            },

            updateMessage(newValue) {
                this.updateTopSiteHeight();
            }
        }
    }
</script>

<style lang="scss">
    .td-top-site-message {
        background-color: #3ec76d;
        padding: 10px 0;
        z-index: 9998;
        width: 100%;
        height: 36px;
        position: relative;

        .td-top-site-message-body {
            display: flex;
            justify-content: center;
        }

        .td-top-site-message-link {
            width: 100%;
            height: 100%;
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
        }

        .td-top-site-message-text {
            color: #fff;
            font-size: 12px;
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            .top-site-btn {
                text-transform: uppercase;
                font-size: 11px;
                margin-left: 8px;
                padding: 1px 7px 2px;
                color: #fff;
                background-color: rgba(0,0,0,0.2);
                border-radius: 2px;
                cursor: pointer;
                transition: background-color 0.15s ease;

                &:hover {
                    opacity: 1;
                    background-color: rgba(0,0,0,0.3);
                }

            }
        }

        &.td-trial-expired,
        &.td-subscription-expired,
        &.td-too-many_employees {
            /*background-color: #bdf3ff;*/
            background: -moz-linear-gradient(left, #b5c2ff 0%, #f5dcff 30%, #f5dcff 70%, #b5c2ff 100%); /* FF3.6-15 */
            background: -webkit-linear-gradient(left, #b5c2ff 0%, #f5dcff 30%, #f5dcff 70%, #b5c2ff 100%); /* Chrome10-25,Safari5.1-6 */
            background: linear-gradient(to right, #b5c2ff 0%, #f5dcff 30%, #f5dcff 70%, #b5c2ff 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
            text-align: center;
            padding: 9px 0;

            .td-top-site-message-text {
                color: #193567;
                font-size: 13px;
                font-weight: 600;
                text-transform: uppercase;
                display: inline-block;
            }

            .td-top-site-message-buy {
                color: #fff;
                font-size: 11px;
                font-weight: 600;
                text-transform: uppercase;
                margin-left: 10px;
                background-color: #ff0000;
                padding: 1px 10px 2px 9px;
                border-radius: 3px;
                position: relative;
                bottom: 1px;
                flex: 0 0 auto;
            }
        }

        .td-top-site-message-close {
            text-align: right;
            position: absolute;
            right: 19px;
            top: -1px;

            @media (max-width: 767px) {
                right: 12px;
            }

            a {
                font-size: 10px;
                line-height: 20px;
                width: 20px;
                height: 20px;
                color: #fff;
                background-color: rgba(0,0,0,0.2);
                border-radius: 50%;
                cursor: pointer;
                transition: background-color 0.15s ease;

                &:hover,
                &:active,
                &:focus {
                    opacity: 1;
                    background-color: rgba(0,0,0,0.3);
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/topSiteMessage.vue